import { useMemo } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * @deprecated Use `useSearchParams`
 * @returns 
 */
export function useQuery() {
  const { search } = useLocation();
  return useMemo(() => new URLSearchParams(search), [search]);
}
